// 🌟 1. 记得在顶部把 factionEvents 引入进来
import { normalEvents, emergencyEvents, factionEvents } from "./events";

const getAvailableEvents = (state, pool) => {
  return pool.filter(e => {
    if (!e.repeatable && state.playedEvents.includes(e.id)) {
      return false;
    }
    return !e.condition || e.condition(state);
  });
};

export const generateNextEvent = async (state) => {
  const isEmergency = Math.random() < 0.2;

  if (isEmergency) {
    const availableEmergencies = getAvailableEvents(state, emergencyEvents);
    if (availableEmergencies.length > 0) {
      const picked = availableEmergencies[Math.floor(Math.random() * availableEmergencies.length)];
      return { status: "emergency", event: picked };
    }
  }

  // 🌟 2. 核心修改：获取当前阵营的专属事件，如果没有就给个空数组
  const currentFactionEvents = factionEvents[state.model] || [];

  // 🌟 3. 将 常规事件 和 专属事件 合并成一个大池子
  const combinedNormals = [...normalEvents, ...currentFactionEvents];

  // 🌟 4. 从合并后的大池子里过滤可用事件
  const availableNormals = getAvailableEvents(state, combinedNormals);

  if (availableNormals.length === 0) {
    return {
      status: "normal",
      event: {
        id: "fallback_boring_week",
        type: "normal",
        title: "平淡的一周",
        description: "本周没有任何突发状况，你可以安心摸鱼了。",
        repeatable: true,
        choices: [
          { text: "带薪拉屎", effect: { san: +10, stability: -5 } }
        ]
      }
    };
  }

  await new Promise(resolve => setTimeout(resolve, 1500));

  const picked = availableNormals[Math.floor(Math.random() * availableNormals.length)];
  return { status: "normal", event: picked };
};